/**
 * CRA entry: React 18 root, React Query provider, global CSS.
 * Run with `npm run dev:vercel` when testing features that need api/* locally.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';

// Suppress the benign ResizeObserver "loop completed" warning that CRA's
// error overlay surfaces as an uncaught runtime error.
const RE_MSG = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (RE_MSG.test(e.message)) { e.stopImmediatePropagation(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
